"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _engineHelper = _interopRequireDefault(require("./engineHelper"));
var _dateHelper = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/dateHelper"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class TimeSelect extends _react.default.Component {
  constructor(props) {
    super(props);
    const {
      activeTime
    } = props;
    this.state = {
      activeTime
    };
    this.handleChange = this.handleChange.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (_engineHelper.default.checkUpdated(nextProps.startingTime, this.props.startingTime)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.startTime, this.props.startTime)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.endTime, this.props.endTime)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.fullWidth, this.props.fullWidth)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.hourSplit, this.props.hourSplit)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.loopOver, this.props.loopOver)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.activeTime, this.props.activeTime)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.showMidnight, this.props.showMidnight)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.hiddenLabel, this.props.hiddenLabel)) return true;
    if (_engineHelper.default.checkUpdated(nextState.activeTime, this.state.activeTime)) return true;
    return false;
  }
  componentDidUpdate(prevProps) {
    if (_engineHelper.default.checkUpdated(this.props.activeTime, this.state.activeTime)) {
      this.handleChange({
        target: {
          value: this.props.activeTime
        }
      });
    }
  }
  loopOver(arr, hourLoops) {
    const {
      startingTime
    } = this.props;
    let startArray = [];
    const endArray = [];
    arr.map(i => {
      if (i * 100 < Number(startingTime)) return endArray.push(i);
      startArray.push(i);
    });
    return startArray.concat(endArray);
  }
  makeOptions() {
    const {
      hourSplit,
      startTime,
      endTime,
      betweenTimes,
      loopOver,
      showMidnight,
      roundTimes,
      addColon
    } = this.props;
    const hourLoops = 24 / hourSplit / 24;
    let arr = Array.apply(null, {
      length: 24
    }).map(Number.call, Number);
    if (loopOver) arr = this.loopOver(arr, hourLoops);
    let iteration, padVal;
    return arr.map(i => {
      const segmentArray = Array.apply(null, {
        length: hourLoops
      }).map(Number.call, Number);
      iteration = 0;
      const incrementIteration = () => {
        iteration = iteration + 60 / hourLoops;
      };
      return segmentArray.map(() => {
        if (i && showMidnight || !showMidnight) {
          if (i * 100 + iteration < startTime) return incrementIteration();
        }
        if (i * 100 + iteration > endTime) return incrementIteration();
        padVal = iteration === 0 && i === 0 ? '0000' : _dateHelper.default.pad(i * 100 + iteration, 4);
        incrementIteration();
        let returnText = padVal.slice(0, 2) + ':' + padVal.slice(-2);
        if (betweenTimes) {
          const nextPadVal = iteration === 0 && i === 0 ? '0000' : _dateHelper.default.pad(i * 100 + iteration, 4);
          let mins = nextPadVal.slice(-2);
          let hours = nextPadVal.slice(0, 2);
          if (!roundTimes) {
            if (Number(mins) >= 60) mins = '60';
            mins = Number(mins) - 1;
          } else if (Number(mins) >= 60) {
            mins = '00';
            hours = _dateHelper.default.pad(Number(hours) + 1, 2);
          }
          returnText += ' - ' + hours + ':' + mins;
        }
        padVal = addColon ? returnText : padVal;
        return /*#__PURE__*/_react.default.createElement("option", {
          key: padVal,
          value: padVal
        }, returnText);
      }).filter(i => {
        return i;
      });
    }).filter(i => {
      return i.length;
    });
  }
  handleChange(e) {
    const {
      value
    } = e.target;
    const {
      name,
      onSelect
    } = this.props;
    if (onSelect) {
      onSelect(name, value);
    }
    this.setState({
      activeTime: value
    });
  }
  render() {
    let {
      className,
      name,
      onError,
      startTime,
      openStart,
      id,
      hiddenLabel,
      onSelect = false
    } = this.props;
    let {
      activeTime
    } = this.state;
    let times = this.makeOptions();
    if (+activeTime < openStart) activeTime = startTime;
    if (activeTime.length < 4) activeTime = _dateHelper.default.pad(activeTime, 4);
    if (!times.length && onError) {
      return /*#__PURE__*/_react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: onError
        }
      });
    } else if (!times.length) {
      times = /*#__PURE__*/_react.default.createElement("option", {
        value: ""
      }, "No options");
    }
    const propParams = {
      onChange: this.handleChange,
      id,
      name,
      className: 'form-control ' + className,
      'data-track-name': name
    };
    propParams[onSelect ? 'value' : 'defaultValue'] = activeTime;
    const hiddenLabelClass = (0, _classnames.default)({
      'hideLabelSplitTest': hiddenLabel
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: hiddenLabelClass
    }, /*#__PURE__*/_react.default.createElement("select", propParams, times));
  }
}
TimeSelect.propTypes = {
  startingTime: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  activeTime: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  name: _propTypes.string,
  fullWidth: _propTypes.bool,
  hourSplit: _propTypes.number,
  startTime: _propTypes.number,
  endTime: _propTypes.number,
  onSelect: _propTypes.func,
  onError: _propTypes.string,
  id: _propTypes.string,
  betweenTimes: _propTypes.bool,
  loopOver: _propTypes.bool,
  showMidnight: _propTypes.bool,
  hiddenLabel: _propTypes.bool,
  roundTimes: _propTypes.bool,
  addColon: _propTypes.bool
};
TimeSelect.defaultProps = {
  startingTime: '1200',
  activeTime: '1200',
  startTime: 15,
  endTime: 2400,
  fullWidth: false,
  hourSplit: 0.5,
  betweenTimes: false,
  loopOver: false,
  showMidnight: false,
  hiddenLabel: false,
  roundTimes: false,
  addColon: false
};
var _default = exports.default = TimeSelect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/times-dropdown.js
// module id = 398
// module chunks = 119